import { render } from "./ShellDetailField.vue?vue&type=template&id=746eaab4&scoped=true&ts=true"
import script from "./ShellDetailField.vue?vue&type=script&lang=ts"
export * from "./ShellDetailField.vue?vue&type=script&lang=ts"

import "./ShellDetailField.vue?vue&type=style&index=0&id=746eaab4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746eaab4"]])

export default __exports__